import dotenv from 'dotenv'

export const getConfig = () => {
  try {
    const config = dotenv.config().parsed
    return config
  } catch (error) {
    return {}
  }
}
